
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__search",
  "use": "icon__search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon__search\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M14.237 3c-3.728 0-6.763 3.034-6.763 6.761 0 1.59.575 3.04 1.503 4.196L3 19.932 4.057 21l5.982-5.98c1.157.927 2.607 1.502 4.198 1.502 3.728 0 6.763-3.034 6.763-6.761C21 6.034 17.965 3 14.237 3zm.013 1.5c2.906 0 5.25 2.344 5.25 5.25S17.156 15 14.25 15 9 12.656 9 9.75s2.344-5.25 5.25-5.25z\" /><path d=\"M0 0h24v24H0z\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconSearchIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__search" {...restProps} />
    })
  